module.exports = __webpack_public_path__ + "static/media/Darius.4d9dda11.png";